import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import Overview from './Overview';

export default class Reports extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Overview = Overview

  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child)
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Reports/Reports.jsx